// src/services/Auth/registerService.js

import { ENDPOINT, HTTP } from "../config";
import { fetchFromLawfeed } from "../fetchFromLawfeed";

export const registerWithSystem = async (formData) => {
  
  try {
    const response = await fetchFromLawfeed({
      method: HTTP.POST,
      endpoint: ENDPOINT.registerWithSystem + formData.tipoUsuario, 
      body: formData,
    });
    // Intentamos obtener el JSON de la respuesta

    const data = await response;

    // Verificamos si hay un error en la respuesta
    if (!response.msg) {
      // Si hay un mensaje de error, lo lanzamos
      return response.error; // En caso de que no haya msg, damos un mensaje por defecto
    }

    // Si no hay error, retornamos el mensaje de éxito
    return data.msg || "Usuario registrado exitosamente"; // En caso de que no haya msg, damos un mensaje por defecto
  } catch (error) {
    console.error("Error en el registro:", error);
    throw new Error(error.message || "Error al registrar usuario");
  }
};
